/** @format */

export const PDP_CONSTANTS = {
	appPathPrefix: 'p'
};

export const adeptmindScriptPath = 'https://www.dickssportinggoods.com/a/js/pdpScript.js';
